import { ItemCache } from '../store/schema/ItemCache';
import { CacheDescriptor } from '../store/schema/CacheDescriptor';
import { checkContainsDescriptor } from './checkContainsDescriptor';

export function hasDescriptor<T, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    itemDescriptor: U,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): boolean {
    const descriptorId = itemDescriptor.Id;
    return (
        store.descriptors.has(descriptorId) ||
        checkContainsDescriptor(store, itemDescriptor, containsDescriptor)
    );
}
